// "Copy output" for a deployment run console (Pages/Agents/_DeploymentOutput.cshtml). The click is
// delegated from the document because the log popover's copy link lives in tui-tooltip content,
// which is cloned out of a <template> each time the tooltip opens. Registered once, from global.ts.
export function initDeploymentOutputCopy(): void {
    document.addEventListener("click", function (event) {
        var target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        var trigger = target.closest("[data-copy-deployment-output]") as HTMLElement | null;
        if (!trigger) {
            return;
        }

        var container = trigger.closest(".tui-tooltip-body, .deployment-run");
        var output = container ? container.querySelector(".deployment-output pre:not(.empty)") : null;
        if (!output || !navigator.clipboard) {
            return;
        }

        navigator.clipboard.writeText(output.textContent || "");

        var label = trigger.textContent;
        trigger.textContent = "Copied";
        window.setTimeout(function () {
            trigger.textContent = label;
        }, 1500);
    });
}
